import classNames from "classnames";
import PropTypes from "prop-types";

export const Map = ({ className, size = 16, fill = "currentColor", ...props }) => {
	const mapClassName = classNames("map-icon", {
		[className]: className?.length > 0,
	});

	return (
		<svg
			className={mapClassName}
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			aria-hidden="true"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.50049 1.69078C5.50044 1.69081 5.50054 1.69076 5.50049 1.69078L2.14541 3.36832C1.75015 3.56595 1.50049 3.96992 1.50049 4.41182V12.4082C1.50049 13.2045 2.28063 13.7668 3.03609 13.515L5.50049 12.6935V1.69078ZM6.50049 12.7581L10.1672 14.3295V3.24153L6.50049 1.6701V12.7581ZM11.1672 3.4998V14.4998H14.6672C15.3115 14.4998 15.8338 13.9775 15.8338 13.3331V4.66647C15.8338 4.02214 15.3115 3.4998 14.6672 3.4998H11.1672Z"
				fill={fill}
			/>
		</svg>
	);
};

Map.propTypes = {
	fill: PropTypes.string,
	size: PropTypes.number,
};
